/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { CandidateOppFeedAlertFrequency } from "../enums";
export const candidateOppFeedAlertSchema = z.object({
  alertName: z.string().nullish(),
  businessTitles: z.array(z.string()).nullish(),
  candidateId: z.string().uuid(),
  countries: z.array(z.string()).nullish(),
  createdAt: z.string().datetime().nullish(),
  engagementLengths: z.array(z.string()).nullish(),
  focusAreas: z.array(z.string()).nullish(),
  frequency: z.nativeEnum(CandidateOppFeedAlertFrequency),
  id: z.string().uuid(),
  industries: z.array(z.string()).nullish(),
  practiceAreas: z.array(z.string()).nullish(),
  updatedAt: z.string().datetime().nullish(),
  weeklyCommitments: z.array(z.string()).nullish(),
  worksites: z.array(z.string()).nullish(),
});

export type CandidateOppFeedAlert = z.infer<typeof candidateOppFeedAlertSchema>;
